export default {
  title: 'Nieuwe variant',
  fields: {
    product: {
      label: 'Product',
    },
    name: {
      label: 'Naam',
      placeholder: 'Groot',
    },
    price: {
      label: 'Extra prijs',
    },
  },
  buttons: {
    save: 'Opslaan',
    close: 'Sluiten',
  },
  toasts: {
    variant_got_created: 'Variant aangemaakt',
    variant_got_updated: 'Variant bijgewerkt',
  },
};
